const tables = [
    {
        name: "Number"
    },
    {
        name: "Date"
    },
    {
        name: "Site"
    },
    {
        name: "Requested By"
    },
    {
        name: "Priority"
    },
    {
        name: "Status"
    },
    {
        name: "Action"
    },
];

export default tables;